export var GlobalActionTypes;
(function (GlobalActionTypes) {
    GlobalActionTypes["HANDLE_BEFORE_DRAG_START"] = "HANDLE_BEFORE_DRAG_START";
    GlobalActionTypes["HANDLE_DRAG_START"] = "HANDLE_DRAG_START";
    GlobalActionTypes["HANDLE_DRAG_UPDATE"] = "HANDLE_DRAG_UPDATE";
    GlobalActionTypes["HANDLE_DRAG_END"] = "HANDLE_DRAG_END";
})(GlobalActionTypes || (GlobalActionTypes = {}));
